import { render, staticRenderFns } from "./DataMappingView.vue?vue&type=template&id=a451ed02&scoped=true"
import script from "./DataMappingView.vue?vue&type=script&lang=js"
export * from "./DataMappingView.vue?vue&type=script&lang=js"
import style0 from "./DataMappingView.vue?vue&type=style&index=0&id=a451ed02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a451ed02",
  null
  
)

export default component.exports